<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Most used templates (Dashboard most used templates widget title) - Most used templates') }}</h4>
  </div>
  <div class="card-body">
  @for(mostUsedTemplates of (fetchMostUsedTemplates$ | async); track mostUsedTemplates){
      <div class="transaction-item">
        <div class="media align-items-center">
          <div class="avatar bg-light-most-used-templates rounded">
            <div class="avatar-content">
              <i class="feather font-medium-3 icon-file-text"></i>
            </div>
          </div>
          <div class="media-body">
            <h6 class="transaction-title activity-Links-h6"><a class="activity-Links" [routerLink]="['/templates']" [state]="{query:mostUsedTemplates.name}">{{mostUsedTemplates.name}}</a></h6>
            <p class="text-muted mb-0 font-small-3">{{ mostUsedTemplates?.document_type?.document_type }}</p>
          </div>
        </div>
        <div><small class="text-muted">{{ mostUsedTemplates.used }}</small></div>
      </div>
    } @empty {
      <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
        <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
      </div>
    }
  </div>
</ng-container>